import type { HandelMembershipPageContent } from '../../theme.types';
import type { MembresiasVariante } from './membresias-variante';

/**
 * De dónde sale el contenido de la página de membresías.
 *
 * Hoy lo entrega el tema (`StaticMembresiasContentSource`); cuando el contenido
 * se administre desde el backoffice, una implementación nueva se registra en
 * `app.config.ts` y ningún componente cambia.
 */
export abstract class MembresiasContentSource {
  abstract load(variante: MembresiasVariante): Promise<HandelMembershipPageContent>;
}
